import cartFunctions from './cartFunctions';

export default {
  functions: [
    ...cartFunctions,
    {
      name: 'getCPProducts',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'plpProducts',
      },
    },
  ],
};
